import { render, staticRenderFns } from "./AdministrationAccessManage.vue?vue&type=template&id=31e302c6&scoped=true"
import script from "./AdministrationAccessManage.vue?vue&type=script&lang=js"
export * from "./AdministrationAccessManage.vue?vue&type=script&lang=js"
import style0 from "./AdministrationAccessManage.vue?vue&type=style&index=0&id=31e302c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e302c6",
  null
  
)

export default component.exports